import { ReactElement, useMemo } from 'react';

import { ReportsDownloadSectionProps } from './types';
import {
  ReportsDownloadSectionVariantBySections,
  ReportsDownloadSectionVariantBySelector,
} from './Variant';

const ReportsDownloadSection = ({
  variant = 'bySections',
}: ReportsDownloadSectionProps): ReactElement => {
  const VariantComponent = useMemo(
    () =>
      variant === 'bySelector'
        ? ReportsDownloadSectionVariantBySelector
        : ReportsDownloadSectionVariantBySections,
    [variant],
  );

  return <VariantComponent />;
};

export default ReportsDownloadSection;
